import { ChatMessageDto } from "./dto";

// Keep in sync with ChatService.MaxAttachmentsPerMessage on the backend
export const CHAT_MAX_ATTACHMENTS = 10;
export const CHAT_MAX_ATTACHMENT_SIZE_MB = 50;

export const CHAT_ATTACHMENT_EXTENSIONS = [
  ".jpg",
  ".jpeg",
  ".png",
  ".gif",
  ".webp",
  ".bmp",
  ".heic",
  ".pdf",
  ".doc",
  ".docx",
  ".xls",
  ".xlsx",
  ".ppt",
  ".pptx",
  ".csv",
  ".txt",
  ".stl",
  ".ply",
  ".obj",
  ".zip",
  ".rar",
  ".7z",
  ".dcm",
  ".mp4",
  ".mov",
];

export const getFileExtension = (fileName: string) => {
  const dotIndex = fileName.lastIndexOf(".");
  return dotIndex === -1 ? "" : fileName.substring(dotIndex).toLowerCase();
};

export const isAllowedChatAttachment = (fileName: string) =>
  CHAT_ATTACHMENT_EXTENSIONS.includes(getFileExtension(fileName));

export const isPreviewableImage = (type?: string) =>
  /^image\/(png|jpe?g|gif|webp|bmp)$/i.test(type ?? "");

// The chat popup sits at z-index 9999 (ChatPopup/styles.less), while antd's image
// preview defaults to 1080 — without this the preview opens behind the popup.
export const CHAT_IMAGE_PREVIEW_Z_INDEX = 10050;

export const formatFileSize = (bytes: number) => {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

// Mirrors the room preview the backend stores for attachment-only messages
export const getMessagePreview = (message: ChatMessageDto) => {
  if (message.message) return message.message;
  const count = message.attachments?.length ?? 0;
  if (count === 0) return "";
  return count === 1 ? "📎 Attachment" : `📎 ${count} attachments`;
};
